import FloorPlateGallery from './floor-plate-gallery'

export default FloorPlateGallery
